import React, { useEffect, useState, useRef } from "react";
import styles from "./manageOrders.module.scss";
import Input from "./input";
import Button from "./button";
import Order from "./order";
import { makeAPICall } from "src/services/apiService";
import { getCookie, postCall, setCookie, getDisplayStatus } from "../../utils/utils";
import { useHistory, useLocation } from "react-router-dom";
import Toast from "../../atoms/toast";
import GenericModal from "../../GenericModal/index";
import FloatingSelect from "../../atoms/floatingSelect/floatingSelect";
import PageLoader from 'src/atoms/pageLoader'

const Index = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showPosOption, setShowPosOption] = useState(false);
  const [xcOrders, setXcOrders] = useState([]);
  const [buyerUtmUuid, setBuyerUtmUuid] = useState("");
  const [xcId, setXcId] = useState("");
  const [xcName, setXcName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isErr, setIsErr] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const [totalOrder, setTotalOrder] = useState(0);
  const loadingEl = useRef();
  const [isIntersecting, setIsIntersecting] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [showToast, setShowToast] = useState("none");
  const [toastMessage, setToastMessage] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("");
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [isFilterSelected, setIsFilterSelected] = useState(false);
  const [orderStatusList, setOrderStatusList] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [isSearchingForOrder, setIsSearchingForOrder] = useState(false);

  const params = new URLSearchParams(location.search);
  const orderid = params.get("order_id");

  const handleSubmit = () => {
    if (phoneNumber?.length != 10) {
      return;
    }
    let config = {
      method: "post",
      url: `/api/user/getUserFromPhone`,
      data: {
        phone_number: phoneNumber,
      },
      headers: {
        oem_auth_token: getCookie("oem_auth_token"),
      },
    };

    makeAPICall(config)
      .then((res) => {
        console.log(res);
        if (res?.data?.status == "SUCCESSFUL") {
          if (res?.data?.data) {
            localStorage.setItem(
              "buyer_user_details",
              JSON.stringify(res?.data?.data)
            );
          } else {
            localStorage.setItem("buyer_user_details", "");
          }
          const userDetails = res?.data?.data?.user_detail;
          if (userDetails && userDetails?.user_tenant_uuid) {
            setCookie("buyer_utm_uuid", userDetails?.user_tenant_uuid);
            setCookie("buyer_name", userDetails?.name);
            redirector();
          } else {
            setCookie("buyer_utm_uuid", "");
            setCookie("buyer_name", "");
          }
        } else {
          setCookie("buyer_utm_uuid", "");
          setCookie("buyer_name", "");
          setShowToast("block");
          setToastMessage("something went wrong");
          setTimeout(() => {
            setShowToast("none");
          }, 2000);
        }
      })
      .catch((err) => {
        console.log(err?.response?.data);
        setCookie("buyer_utm_uuid", "");
        setCookie("buyer_name", "");
        if (err?.response?.data?.status == "Fury Details not found for user.") {
          setToastMessage("user not found");
        } else {
          if (err?.response?.data?.message) {
            setToastMessage(err?.response?.data?.message);
          } else {
            setToastMessage("something went wrong");
          }
        }
        setShowToast("block");
        setTimeout(() => {
          setShowToast("none");
        }, 2000);
      });
  };
  const redirector = () => {
    const hasUserOrders = JSON.parse(localStorage.getItem("buyer_user_details"))
      ?.order_detail?.user_orders?.length;
    if (!hasUserOrders) {
      history.push("/create-order");
    } else {
      const url =
        JSON.parse(localStorage.getItem("env_const"))?.purchase_url || "";
      postCall(`${url}/cloakCustomer`, {
        redirectUrl: "/myReservations",
      });
    }
  };

  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 1.0,
  };

  const handleIntersection = (entries) => {
    const [entry] = entries;
    setIsIntersecting(entry.isIntersecting);
  };

  const updateOrderStatusList = () => {
    setFilterList([
      {
        label: "All",
        value: "",
      },
      {
        label: "Ordered",
        value: "ORDERED"
      },
      {
        label: "Documents Uploaded",
        value: "DOCUMENTS_UPLOADED"
      },
      {
        label: "Documents Verified",
        value: "DOCUMENTS_VERIFIED"
      },
    ])
  }

  useEffect(() => {
    let observer = new IntersectionObserver(handleIntersection, options);
    if (loadingEl?.current) {
      observer.observe(loadingEl?.current);
    }
    return () => {
      if (loadingEl?.current) {
        observer.unobserve(loadingEl?.current);
      }
    };
  }, [loadingEl, options]);

  useEffect(() => {
    if (isIntersecting) {
      console.log(xcOrders, pageCount + 1);
      setPageCount(pageCount + 1);
    }
  }, [isIntersecting]);

  useEffect(() => {
    isPosEnabled();
    updateOrderStatusList();
    if (orderid) {
      setIsSearchingForOrder(true);
    }
  }, []);

  useEffect(() => {
    const filterParam = params.get("filter");
    if (filterParam !== null && filterList.length) {
      const found = filterList.find(f => f.value === filterParam);
      if (found) {
        setSelectedFilter(found);
        setIsFilterSelected(true);
      }
    }
  }, [filterList, location.search]);

  useEffect(() => {
    if (showPosOption && !selectedFilter) {
      let config = {
        method: "post",
        url: `/api/xc/getXcOrders?page=${pageCount}&status=&size=100`,
        headers: { oem_auth_token: getCookie("oem_auth_token"), xc: xcName },
      };
      makeAPICall(config)
        .then((res) => {
          const newOrders = res?.data?.data?.orders || [];
          const allOrders = xcOrders.length ? [...xcOrders, ...newOrders] : newOrders;
          const exp_center_source_id = params.get("exp_center_source_id");
          if(exp_center_source_id){
          setCookie("exp_order_source_id", exp_center_source_id);
          }
          
          if (xcOrders.length) {
            setXcOrders(allOrders);
          } else {
            setXcOrders(res?.data?.data?.orders);
          }
          setTotalOrder(res?.data?.data?.total_count);

          if (orderid) {
            const orderData = allOrders.find((order) => order.order_id === orderid);
            if (!orderData && allOrders.length >= (res?.data?.data?.total_count || 0)) {
              setToastMessage("Order ID not found");
              setShowToast("block");
              setIsSearchingForOrder(false);
              setTimeout(() => setShowToast("none"), 4000);
            }
          }
        })
        .catch((err) => {
          console.log(err);
          if (orderid) {
            setIsSearchingForOrder(false);
          }
        });
    }
  }, [showPosOption, pageCount, selectedFilter]);
  useEffect(() => {
    if (showPosOption && selectedFilter) {
      fetchFilteredList();
    }
  }, [selectedFilter, showPosOption]);

  function isPosEnabled() {
    let config = {
      method: "get",
      url: `/api/pos/isPosAvailable`,
    };
    makeAPICall(config)
      .then((response) => {
        if (response && response?.data && response?.data?.isEligiblePos) {
          setShowPosOption(true);
          const exp_center_source_id = params.get("exp_center_source_id");
          if (exp_center_source_id) {
            setCookie("exp_order_source_id", exp_center_source_id);
          } else {
            setCookie("exp_order_source_id", response?.data?.experienceCenterId);
          }
          setXcId(response?.data?.experienceCenterId || "");
          // set Xc and Xc Id
        }
        console.log(response, "mo");
      })
      .catch((e) => {
        console.log("Fail ", e);
      });
  }

  const phoneNumberChange = (e) => {
    if (e.target.value && /^[0-9]/gi.test(e.target.value)) {
      let val = e.target.value.replace(/[^\d]/g, "");
      if (val.length === 1 && val < 6) {
        return;
      }
      if (val.length > 10) {
        return phoneNumber;
      } else {
        return val;
      }
    }
  };

  const fetchFilteredList = () => {
    let config = {
      method: "post",
      url: `/api/xc/getXcOrders?page=1&status=${selectedFilter?.value}`,
      headers: { oem_auth_token: getCookie("oem_auth_token"), xc: xcName },
    };
    makeAPICall(config)
      .then((res) => {
        setXcOrders(res?.data?.data?.orders);
        setTotalOrder(res?.data?.data?.total_count);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchOrderStatusList = () => {
    let config = {
      method: "get",
      url: `/api/xc/getOrderStatusList`,
    };
    makeAPICall(config)
      .then((res) => {
        if (res?.data?.data) {
          let statusList = res?.data?.data;
          statusList = statusList?.map((item) => {
            return {
              label: item,
              value: item,
            };
          });
          statusList.unshift({
            label: "ALL",
            value: "",
          });
          setFilterList(statusList);
        } else {
          setFilterList([]);
        }
      })
      .catch((err) => {
        console.log(err);
        setFilterList([]);
      });
  };

  const handleSelectFilter = (el) => {
    setSelectedFilter(el);
    setIsFilterSelected(true);
    setShowFilterDropdown(false);
  };

  useEffect(() => {
    if (showPosOption && selectedFilter) {
      fetchFilteredList();
    }
  }, [selectedFilter]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const orderid = params.get("order_id");
    if (orderid) {
      if (xcOrders.length) {
        const orderData = xcOrders.find((order) => order.order_id === orderid);
        if (orderData) {
          const url = JSON.parse(localStorage.getItem("env_const"))?.purchase_url || "";
          postCall(`${url}/cloakCustomer`, {
            redirectUrl: `/orderDetail?show=order_detail&orderID=${orderData?.order_id}`,
            buyer_utm_uuid: orderData?.user_id,
            buyer_name: orderData?.customer_name,
          });
        } else {
          // This part is now handled in the fetch useEffect to avoid showing loader indefinitely
        }
      }
    }
  }, [location.search, xcOrders]);

  if (orderid && isSearchingForOrder) {
    return (
      <div className={styles["loader-full-screen"]}>
        <span className={styles["loader"]}><PageLoader /></span>
      </div>
    );
  }

  return showPosOption ? (
    <div className={styles["outer-wrapper"]}>
      <img
        src="https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/extendedWarranty/BackArrowWithWhiteBackground.svg"
        alt="back"
        className={styles["back-icon"]}
        onClick={() => {
          history.push("/booking-list");
        }}
      />
      <div className={styles["one"]}>
        <h3>Manage orders</h3>
        {/* <img
          src="https://d34kmefuuy0be0.cloudfront.net/ev_assets/user_24a528774c.svg"
          alt="user-icon"
        /> */}
      </div>
      <div className={styles["two"]}>
        <img
          src="https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/images/delivery_Location_icon.svg"
          alt="map-icon"
        />
        <p>
          {xcId.split("-").length > 1
            ? xcId.split("-").slice(1).join(" ")
            : xcId}
        </p>
      </div>

      <div className={styles["three"]}>
        <Input
          type="phoneNumber"
          value={phoneNumber}
          placeholder="Enter customer mobile number"
          onChange={(e) => {
            setPhoneNumber(phoneNumberChange(e));
          }}
        />
      </div>
      <div className={styles["four"]}>
        <Button
          isDisabled={phoneNumber?.length == 10 ? false : true}
          label="Submit"
          onClick={handleSubmit}
        />
      </div>

      <div className={styles["five"]}>
        <h4>RECENT ORDERS/DRAFTS</h4>

        {filterList?.length && (
          <div className={styles.dropdownWrapper}>
            <FloatingSelect
              labelName="Filters"
              inputValue={selectedFilter?.label}
              onChange={() => setShowFilterDropdown(!showFilterDropdown)}
              isSelected={isFilterSelected}
            />
          </div>
        )}
        {xcOrders?.map((order, i) => (
          <Order
            scooter_img={order?.order_metadata?.image_url}
            customer_name={order?.customer_name}
            status={getDisplayStatus(order?.status) || order?.status}
            model={order?.order_metadata?.name}
            orderData={order}
          />
        ))}
        {xcOrders?.length < totalOrder && (
          <span className={styles["loader"]} ref={loadingEl}>
            loading..
          </span>
        )}
      </div>
      <Toast toastMessage={toastMessage} showToast={showToast} />
      {showFilterDropdown && (
        <GenericModal
          onClose={() => {
            setShowFilterDropdown(false);
          }}
          showClose={false}
          botSheet={true}
        >
          <div className={styles["eb-common-div"]}>
            <div className={styles["eb-drop-down-title"]}>Filter</div>
            <div>
              {filterList.map((el, i) => (
                <div
                  onClick={() => {
                    handleSelectFilter(el);
                  }}
                  className={styles["eb-common-single-div"]}
                  key={i}
                >
                  {el?.label}
                </div>
              ))}
            </div>
          </div>
        </GenericModal>
      )}
    </div>
  ) : (
    <></>
  );
};

export default Index;
